(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-benefits"] && !Shopify.designMode) return;
  try {
    
  function initWarranty(root) {
    if (root.dataset.warrantyReady === 'true') return;
    root.dataset.warrantyReady = 'true';

    const links = Array.from(root.querySelectorAll('[data-spy-link]'));
    const sections = Array.from(root.querySelectorAll('[data-spy]'));
    const linkById = new Map(links.map((link) => [link.getAttribute('href').slice(1), link]));

    function setCurrent(id) {
      links.forEach((link) => link.removeAttribute('aria-current'));
      const current = linkById.get(id);
      if (current) current.setAttribute('aria-current', 'true');
    }

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const id = link.getAttribute('href').slice(1);
        const target = root.querySelector('#' + CSS.escape(id));
        if (!target) return;
        event.preventDefault();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        setCurrent(id);
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) setCurrent(visible.target.id);
        },
        { rootMargin: '-20% 0px -55% 0px', threshold: [0.15, 0.4] }
      );
      sections.forEach((section) => observer.observe(section));
    }

    const lightbox = root.querySelector('[data-warranty-lightbox]');
    const openButton = root.querySelector('[data-warranty-open]');
    if (lightbox && openButton) {
      const slides = Array.from(lightbox.querySelectorAll('[data-warranty-slide]'));
      const stage = lightbox.querySelector('[role="dialog"]');
      let index = 0;
      let lastFocus = null;

      function showSlide(next) {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });
      }

      function onKey(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeLightbox();
        } else if (event.key === 'ArrowLeft') {
          showSlide(index - 1);
        } else if (event.key === 'ArrowRight') {
          showSlide(index + 1);
        }
      }

      function openLightbox() {
        lastFocus = document.activeElement;
        lightbox.hidden = false;
        document.documentElement.classList.add('warranty-lightbox-open');
        showSlide(0);
        document.addEventListener('keydown', onKey);
        if (stage) stage.focus({ preventScroll: true });
      }

      function closeLightbox() {
        if (lightbox.hidden) return;
        lightbox.hidden = true;
        document.documentElement.classList.remove('warranty-lightbox-open');
        document.removeEventListener('keydown', onKey);
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        lastFocus = null;
      }

      openButton.addEventListener('click', openLightbox);
      lightbox.querySelectorAll('[data-warranty-close]').forEach((control) => {
        control.addEventListener('click', closeLightbox);
      });
      const previous = lightbox.querySelector('[data-warranty-prev]');
      const next = lightbox.querySelector('[data-warranty-next]');
      if (previous) previous.addEventListener('click', () => showSlide(index - 1));
      if (next) next.addEventListener('click', () => showSlide(index + 1));
    }

    const notice = root.querySelector('[data-warranty-notice]');
    const noticeOpen = root.querySelector('[data-warranty-notice-open]');
    if (notice && noticeOpen) {
      const panel = notice.querySelector('[role="dialog"]');
      let noticeFocus = null;

      function onNoticeKey(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeNotice();
        }
      }

      function openNotice() {
        noticeFocus = document.activeElement;
        notice.hidden = false;
        document.documentElement.classList.add('warranty-lightbox-open');
        document.addEventListener('keydown', onNoticeKey);
        if (panel) panel.focus({ preventScroll: true });
      }

      function closeNotice() {
        if (notice.hidden) return;
        notice.hidden = true;
        document.documentElement.classList.remove('warranty-lightbox-open');
        document.removeEventListener('keydown', onNoticeKey);
        if (noticeFocus && typeof noticeFocus.focus === 'function') noticeFocus.focus();
        noticeFocus = null;
      }

      noticeOpen.addEventListener('click', openNotice);
      notice.querySelectorAll('[data-warranty-notice-close]').forEach((control) => {
        control.addEventListener('click', closeNotice);
      });
    }

    const formBody = root.querySelector('[data-required-message]');
    if (!formBody) return;
    const form = formBody.closest('form');
    if (!form) return;
    form.querySelectorAll('[required]').forEach((field) => {
      field.addEventListener('invalid', (event) => {
        event.preventDefault();
        const wrap = field.closest('.warranty-field');
        if (wrap) wrap.classList.add('is-invalid');
      });
      field.addEventListener('input', () => {
        const wrap = field.closest('.warranty-field');
        if (wrap && field.checkValidity()) wrap.classList.remove('is-invalid');
      });
      field.addEventListener('change', () => {
        const wrap = field.closest('.warranty-field');
        if (wrap && field.checkValidity()) wrap.classList.remove('is-invalid');
      });
    });
  }

  function bootWarranty() {
    document.querySelectorAll('[data-warranty]').forEach(initWarranty);
  }

  bootWarranty();
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-warranty]');
    if (root) initWarranty(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-anchors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pageAnchorsBoot) return;
    window.__pageAnchorsBoot = true;

    let scrollLock = '';
    let scrollLockTimer = 0;

    function headerOffset() {
      let bottom = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < 120) bottom = Math.max(bottom, rect.bottom);
      });
      if (bottom > 0) return Math.round(bottom);
      const header = document.querySelector('.section-header');
      if (!header) return 0;
      return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    }

    function place() {
      const nav = document.querySelector('[data-page-anchors]');
      if (!nav) return;
      const root = document.documentElement;
      const stick = headerOffset();
      const spacer = document.querySelector('[data-page-anchors-spacer]');
      const mobile = window.matchMedia('(max-width: 989px)').matches;
      if (!mobile) {
        nav.classList.remove('is-fixed');
        if (spacer) spacer.style.height = '0px';
        const first = document.querySelector('[data-page-anchor]');
        const content = first && first.querySelector('.page-anchor-content');
        const link = nav.querySelector('.page-anchors__link');
        const linkPad = link ? parseFloat(getComputedStyle(link).paddingTop) || 0 : 0;
        const beside = content ? content.getBoundingClientRect().top - linkPad : stick;
        const top = Math.max(stick + 8, beside);
        root.style.setProperty('--page-anchor-top', top + 'px');
        const navWidth = nav.offsetWidth;
        const viewport = root.clientWidth;
        const edge = 28;
        const gutter = 80;
        const centeredLeft = Math.max(0, (viewport - 1200) / 2);
        const contentLeft = Math.max(centeredLeft, navWidth + edge + gutter);
        const navLeft = Math.max(edge, contentLeft - navWidth - gutter);
        root.style.setProperty('--page-anchor-left', navLeft + 'px');
        root.style.setProperty('--page-anchor-content-left', contentLeft + 'px');
        root.style.setProperty('--page-anchor-scroll', stick + 16 + 'px');
        return;
      }
      const section = nav.closest('.shopify-section');
      const bar = nav.offsetHeight;
      const sectionTop = section ? section.getBoundingClientRect().top + window.scrollY : 0;
      const pin = window.scrollY + stick + 1 >= sectionTop;
      nav.classList.toggle('is-fixed', pin);
      if (spacer) spacer.style.height = pin ? bar + 'px' : '0px';
      root.style.setProperty('--page-anchor-top', stick + 'px');
      root.style.removeProperty('--page-anchor-left');
      root.style.removeProperty('--page-anchor-content-left');
      root.style.setProperty('--page-anchor-scroll', stick + bar + 12 + 'px');
    }

    function setActive(id) {
      document.querySelectorAll('.page-anchors__link').forEach((link) => {
        const on = link.getAttribute('data-anchor-id') === id;
        link.classList.toggle('is-active', on);
        if (on) {
          link.setAttribute('aria-current', 'true');
          const bar = link.closest('[data-page-anchors]');
          if (bar && bar.scrollWidth > bar.clientWidth + 1) {
            bar.scrollTo({ left: Math.max(0, link.offsetLeft - 24), behavior: 'smooth' });
          }
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function sectionInView() {
      const sections = Array.from(document.querySelectorAll('[data-page-anchor]'));
      if (!sections.length) return null;
      const line = headerOffset() + 72;
      let current = sections[0];
      sections.forEach((section) => {
        const content = section.querySelector('.page-anchor-content') || section;
        if (content.getBoundingClientRect().top <= line) current = section;
      });
      return current;
    }

    function syncFromScroll() {
      if (scrollLock) return;
      const current = sectionInView();
      if (current) setActive(current.id);
    }

    function lockActive(id) {
      scrollLock = id;
      window.clearTimeout(scrollLockTimer);
      const unlock = () => {
        if (scrollLock !== id) return;
        scrollLock = '';
        setActive(id);
      };
      if ('onscrollend' in window) window.addEventListener('scrollend', unlock, { once: true });
      scrollLockTimer = window.setTimeout(unlock, 1000);
    }

    function rebuild() {
      const nav = document.querySelector('[data-page-anchors]');
      const list = document.querySelector('[data-page-anchors-list]');
      if (!nav || !list) return;
      const sections = Array.from(document.querySelectorAll('[data-page-anchor]'));
      list.replaceChildren();
      const designMode = window.Shopify && Shopify.designMode;
      if (!sections.length) {
        nav.hidden = !designMode;
        nav.classList.add('is-empty');
        document.documentElement.classList.remove('has-page-anchors');
        return;
      }
      nav.classList.remove('is-empty');
      nav.hidden = false;
      document.documentElement.classList.add('has-page-anchors');
      sections.forEach((section) => {
        const link = document.createElement('a');
        link.className = 'page-anchors__link';
        link.setAttribute('href', '#' + section.id);
        link.setAttribute('data-anchor-id', section.id);
        link.textContent = section.getAttribute('data-page-anchor');
        link.addEventListener('click', (event) => {
          event.preventDefault();
          setActive(section.id);
          lockActive(section.id);
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + section.id);
        });
        list.appendChild(link);
      });
      const hash = window.location.hash.slice(1);
      const fromHash = sections.find((section) => section.id === hash);
      const current = fromHash || sectionInView() || sections[0];
      setActive(current.id);
      place();
    }

    document.addEventListener('shopify:section:load', rebuild);
    document.addEventListener('shopify:section:unload', rebuild);
    document.addEventListener('shopify:section:reorder', rebuild);
    window.addEventListener('resize', place);
    window.addEventListener('scroll', () => {
      place();
      syncFromScroll();
    }, { passive: true });
    window.addEventListener('load', place);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rebuild);
    } else {
      rebuild();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-usage-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initUsageVideos(root) {
      if (!root || root.dataset.usageReady === 'true') return;
      root.dataset.usageReady = 'true';
      const buttons = root.querySelectorAll('[data-tab]');

      function showTab(handle) {
        buttons.forEach((button) => {
          const on = button.getAttribute('data-tab') === handle;
          button.classList.toggle('is-active', on);
          button.setAttribute('aria-selected', on ? 'true' : 'false');
          if (!on) return;
          const bar = button.closest('.usage-videos__tabs');
          if (bar && bar.scrollWidth > bar.clientWidth + 1) {
            bar.scrollTo({ left: Math.max(0, button.offsetLeft - 24), behavior: 'smooth' });
          }
        });
        root.querySelectorAll('[data-panel]').forEach((panel) => {
          panel.hidden = panel.getAttribute('data-panel') !== handle;
        });
      }

      buttons.forEach((button) => {
        button.addEventListener('click', () => showTab(button.getAttribute('data-tab')));
      });

      root.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-panel]');
        if (panel) {
          showTab(panel.getAttribute('data-panel'));
          return;
        }
        const tab = event.target.closest('[data-tab]');
        if (tab) showTab(tab.getAttribute('data-tab'));
      });
    }

    function boot(scope) {
      const target = scope || document;
      if (target.matches && target.matches('[data-usage-videos]')) initUsageVideos(target);
      target.querySelectorAll('[data-usage-videos]').forEach(initUsageVideos);
    }

    boot(document);
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
